<template>
    <div class="kgk-team-invites-list">
        <h4>Ausstehende Einladungen</h4>
        <div v-if="!invites || invites.length == 0">
            Keine Einladungen.
        </div>
        <div v-else>
            <table>
                <thead>
                    <tr>
                        <!--<td>Avatar</td>-->
                        <th>Läufer</th>
                        <th>Eingeladen von</th>
                        <th>Zeitpunkt</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invite) in localInvites"
                        :key="invite.identifier">
                        <td>
                            <div class="kgk-mobile-th">Läufer:</div>
                            {{ invite.user_username }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Eingeladen von:</div>
                            {{ invite.issuer_username }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Zeitpunkt:</div>
                            {{ convertDatetimeReadable(invite.created_at) }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Aktionen:</div>
                            <div class="kgk-actions">
                                <a @click.prevent="cancelInvite(invite)" href="#" v-tooltip="'Einladung zurückziehen'">
                                    <i v-if="!invite.loading" class="fas fa-minus-circle fa-fw"></i>
                                    <i v-else class="fas fa-spinner fa-spin fa-fw"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-if="teamIsFull">
                <i class="fas fa-info-circle"></i> Solange dein Team die maximale Anzahl an Teammitgliedern hat, können die weiteren eingeladenen Läufer Ihre Einladung nicht annehmen.
            </p>
        </div>
    </div>
</template>

<script>
import team from '../../api/team';

export default {
    name: 'TeamInvitesList',
    props: {
        invites: [Array, Object], 
        members: {
            type: Array,
            default: () => []
        },
        teamIsFull: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localInvites: []
        }
    },
    watch: {
        invites: {
            immediate: true,
            handler(newVal) {
                this.prepareLocalInvites();
            },
            deep: true
        }
    },
    methods: {
        prepareLocalInvites() {
            let rawArray = [];
            
            if (Array.isArray(this.invites)) {
                
                rawArray = this.invites;
            } else if (this.invites && Array.isArray(this.invites.invites)) {
                rawArray = this.invites.invites;
            }

            const pendingInvites = rawArray.filter(invite => {
                return invite.status === 'pending';
            });

            if (pendingInvites.length === 0) {
                this.localInvites = [];
                return;
            }

            this.localInvites = pendingInvites.map(invite => ({
                ...invite,
                loading: false,
                user_username: invite.user?.username || 'Unbekannt',
                issuer_username: invite.issuer?.username || 'Unbekannt'
            }));

        },
        cancelInvite(invite) {
            if (invite.loading) return;

            invite.loading = true;

            team.cancelInvite(
                this,
                invite.identifier,
                () => {
                    this.$notify({
                        type: 'success',
                        title: 'Einladung entfernt',
                        text: 'Die Einladung wurde erfolgreich zurückgezogen.'
                    });
                    this.$emit('cancelled');
                },
                e => {
                    invite.loading = false;
                    const errorMsg = (e.response?.data?.message) 
                                     ? e.response.data.message 
                                     : 'Es ist ein unbekannter Fehler aufgetreten.';
                    
                    this.$notify({
                        type: 'error',
                        title: 'Fehler',
                        text: errorMsg
                    });
                },
                () => {}
            );
        }
    }
}
</script>